import React from 'react';
import './MonthlyRental.css';

import { Heading } from '../../../components';
import { monthlyRental } from '../../../constants';
import { renderIcon } from '../../../utils';

import { Link } from 'react-router-dom';  


    
const MonthlyRental = () => { 

  return (
    <section className='services'>
 
      {/* Section heading */}
      <Heading title={'上班通勤想找月租車位嗎？'} subTitle={'大潤發各門市停車場提供月租車位服務'} />

      <div className='box-container'>    
        {// Map through the serviceContent array and render service items
          monthlyRental.map((service) => { 

            return (
              <div className='service-item' key={service.id}>

                {/* Service Image Container */}
                <div className='image'>
                  <img src={service.image} alt='' /> {/* Service Image */}
                  <div className='icon'>{renderIcon('rental')}</div> {/* Service Icon */}
                </div>
 
                {/* Service Content Container */}
                <div className='content'>
                  {/* Link to the individual service page */}
                  <Link
                    to={{ 
                      // pathname: '/Services/' + service.title,
                    }}
                    location = {{service}}
                    state= {service}><h3>{service.title}</h3> {/* Service Title */}
                  </Link>
                  <p>{service.content}</p> {/* Service Content */}
                </div>


                
              </div>
            )
          })
        }
      </div>
 
    </section>
  )
}

export default MonthlyRental